import { Link } from 'react-router-dom';
import { articles } from '@/mocks/superbuy';

export default function ArticleCards() {
  return (
    <section id="guides" className="py-24 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 gap-6">
          <div>
            <span className="inline-block text-xs tracking-[0.25em] uppercase text-primary-600 font-medium mb-4 border border-primary-300/50 px-3 py-1 rounded-full">
              Expert Guides
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
              Learn & Level Up
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md">
            In-depth articles covering everything from beginner basics to advanced shopping strategies — written to help you shop smarter
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article, i) => (
            <Link
              key={article.slug}
              to={article.slug}
              className={`group block rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 ${
                i === 1 ? 'bg-primary-800' : 'bg-background-50'
              }`}
            >
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className={`inline-block text-xs font-medium px-2.5 py-1 rounded-full mb-3 ${
                  i === 1 ? 'bg-primary-500/30 text-background-50 dark:text-foreground-950' : 'bg-primary-100 text-primary-700'
                }`}>
                  {article.tag}
                </span>
                <h3 className={`font-heading text-lg md:text-xl font-semibold mb-2 leading-snug group-hover:underline ${
                  i === 1 ? 'text-background-50 dark:text-foreground-950' : 'text-foreground-950'
                }`}>
                  {article.title}
                </h3>
                <p className={`text-sm leading-relaxed ${
                  i === 1 ? 'text-background-50/80 dark:text-foreground-900' : 'text-foreground-600'
                }`}>
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}